export { default, ManagerTableCellLabel } from './ManagerTableCellLabel';